import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { getCentrifugeTokenFailed, getCentrifugeTokenSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { DEFAULT_URL } from '../../../configs';

export default function* getCentrifugeToken(action) {
  try {
    const url = `${DEFAULT_URL}/api/centrifugo/get-connection-token`;
    const response = yield makeRequest(url, {}, action, 'GET', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(getCentrifugeTokenSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(getCentrifugeTokenFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(getCentrifugeTokenFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
